module.exports = __webpack_public_path__ + "img/policia_ministerial_up_selected.7abe454d.svg";